<template>
  <div class="float-right">
    <button
      v-if="savedGrants.includes(grant.Grant_Id)"
      v-on:click="unstar()"
      class="btn btn-success"
    >
      Remove from My Grants
    </button>
    <button
      v-else
      v-on:click="saveGrant(grant.Grant_Id)"
      class="btn btn-outline-success"
    >
      Add to My Grants
    </button>
    <ConfirmationModal
      @cancel="cancelled"
      @confirm="confirmed"
      v-bind:Title="'Remove Grant'"
      v-bind:Description="removeDescription"
      v-bind:ConfirmText="'Remove'"
      v-bind:Id="id"
    />
  </div>
</template>

<script>
import ConfirmationModal from "@/modals/ConfirmationModal.vue";
import $ from "jquery";

export default {
  name: "Template",
  components: {
    ConfirmationModal
  },
  props: {
    SavedGrants: Array,
    Grant: Object
  },
  data() {
    return {
      savedGrants: this.SavedGrants,
      grant: this.Grant,
      confirmation: false,
      removeDescription:
        "Are you sure you want to remove " +
        this.Grant.Title +
        ' from "Saved Grants? This will remove all reminders related to this grant.',
      id: "confirmationModal" + this.Grant.Grant_Id
    };
  },
  methods: {
    unstar() {
      this.confirmation = true;
      $("#" + this.id).modal("show");
    },
    async confirmed() {
      await this.removeGrant(this.grant.Grant_Id);
      this.confirmation = false;
    },
    cancelled() {
      this.confirmation = false;
    },
    async removeGrant(grantId) {
      var view = this;
      view.$store.commit("updateLoading", true);
      try {
        var res = await view.$store.getters.fetcher({
          query: `mutation($grantId: Int!, $userId: Int!){
            RemoveGrantApplicationByGrantAndUser(grantId: $grantId, userId: $userId)
          }`,
          variables: {
            grantId: parseInt(grantId),
            userId: parseInt(view.$store.getters.user.User_Id)
          }
        });
        //remove saved grant id from the user object
        var user = Object.assign({}, view.$store.getters.user);
        var userDeletedIndex = user.Saved_Grants.findIndex(
          g => g.Grant_Id == res.data.RemoveGrantApplicationByGrantAndUser
        );
        user.Saved_Grants.splice(userDeletedIndex, 1);
        //remove the saved grant from the local saved grants list
        var viewDeletedIndex = view.savedGrants.findIndex(
          g => g == res.data.RemoveGrantApplicationByGrantAndUser.toString()
        );
        view.savedGrants.splice(viewDeletedIndex, 1);
      } catch (e) {
        console.log(e);
        view.$store.commit("updateLoading", false);
      }
      view.$emit("updatedSavedGrants");
      view.$store.commit("updateLoading", false);
    },
    async saveGrant(grantId) {
      var view = this;
      view.$store.commit("updateLoading", true);
      try {
        var res = await view.$store.getters.fetcher({
          query: `mutation($grantId: Int!, $userId: Int!){
            CreateGrantApplication(grantId: $grantId, userId: $userId){
              Grant_Id
            }
          }`,
          variables: {
            grantId: parseInt(grantId),
            userId: parseInt(view.$store.getters.user.User_Id)
          }
        });
        //add grant to user grant list
        var user = Object.assign({}, view.$store.getters.user);
        if (user.Saved_Grants == undefined) {
          user.Saved_Grants = [
            {
              Grant_Id: res.data.CreateGrantApplication.Grant_Id
            }
          ];
        } else {
          user.Saved_Grants.push({
            Grant_Id: res.data.CreateGrantApplication.Grant_Id
          });
        }
        //add grant to the local saved grants list
        view.savedGrants.push(
          res.data.CreateGrantApplication.Grant_Id.toString()
        );
        view.$store.commit("updateUser", user);
      } catch (e) {
        console.log(e);
        view.$store.commit("updateLoading", false);
      }
      view.$emit("updatedSavedGrants");
      view.$store.commit("updateLoading", false);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
